import React, {useState, Fragment} from 'react';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import { Card, CardContent, Grid } from '@mui/material';
import TituloConIcono from 'components/tituloConIcono';
import { Cancel, Send  } from '@mui/icons-material';
import { TablaPersonalizada } from 'components';
import Formulario from 'components/formulario';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import { useHistory } from 'react-router-dom';
import {useDispatch} from 'react-redux';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import MostrarInformacion from './MostrarInformacion';
import Buscador from 'pages/buscador';
import { functions } from 'constantes';
import { nuevoOActualizarRegistroPersonalizado, obtenerRegistrosPersonalizadoPublic } from 'store/actions/customAction';

let datosDelFormularioFiltrado = {};
let informacionObtenida = {};

const GeneracionSolicitudTransmision = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
    const [mostrarInformacion, setMostrarInformacion] = useState(false);
    const [listadoDeRegistrosDeMedios, setListadoDeRegistrosDeMedios] = useState([]);
    const [ordenesDeTransmision] = useState("ordenesDeTransmision");

    const [header] = useState([
        { title: 'Nit', field: 'nitEmpresa', cellStyle:{ maxWidth: '80px' }},
        { title: 'Nombre del medio', field: 'nombreMedio'},
        { title: 'Fecha Inicio', field: 'rangoInicial'},
        { title: 'Fecha Final', field: 'rangoFinal'},
        { title: 'Acciones', field: 'accion',
        render: rowData=><div style={{minWidth: '100px'}}>
            {
                (<div>
                    <TooltipPersonalizado title="Ver Información" handleFunction={() => accionMostrarInformacion(rowData)} icon="visibility" fontSize={30} marginTop="0" />
                    <TooltipPersonalizado title="Seleccionar elemento" handleFunction={() => accionSeleccionarElemento(rowData)}
                    icon="check_circle" fontSize={30} marginTop="0" />
                </div>)
            }
            </div>
        },
    ]);

    const accionSeleccionarElemento = async (rowData) => {
        const nuevosElementos = Object.assign({}, elementos);
        const {nombreMedio, nombreEmpresa, tipoEleccion, rangoInicial, rangoFinal, idMedio} = rowData;
        datosDelFormularioFiltrado = {...datosDelFormularioFiltrado, idMedio}
        
        nuevosElementos.nombreDelMedio.value = nombreMedio || ""
        nuevosElementos.nombreDeLaEntidad.value = nombreEmpresa || ""
        nuevosElementos.tipoDeCandidatura.value = tipoEleccion || ""
        nuevosElementos.fechaDeGeneracion.value = `${rangoInicial || ""} AL ${rangoFinal || ""}` || ""
      setearElementos(nuevosElementos)
    }

    const accionMostrarInformacion = async (rowData) => {
        informacionObtenida = rowData;
        setMostrarInformacion(true)
    }

    const guardarDatos = async (datosDelFormulario) => {
        setcargandoSolicitud(true);

        const copiaDeCampos = Object.assign({}, elementos)

       const{ comentarioVersion, comentarioInstrucciones, enlaceDeMaterial } = datosDelFormulario;
       const {fechaDeOrdenes, idMedio, nivelDeCobertura, tipoDeCandidatura } = datosDelFormularioFiltrado;

        const datosAEnviar = {
            controller: ordenesDeTransmision, action: "crear",
            data: {
                "idFecha": fechaDeOrdenes?.id || "",
                "idMedio": idMedio, // 1.- TELEVSION
                "idNivelCobertura": nivelDeCobertura?.id || "", //1.- NACIONAL
                "idTipoEleccion": tipoDeCandidatura?.id || "", // 1. PRESIDENTE
                "instruccionesEspeciales": comentarioInstrucciones,
                "versionOrdenDeCompra":comentarioVersion,
                enlaceDeMaterial
            },
        };

        const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));

        setcargandoSolicitud(false);
        if(respuesta?.error) return changeDataResponse('error', respuesta?.error?.message || 'No se pudó guardar los datos', true, );

        if(respuesta?.data?.length === 0) return changeDataResponse('error', respuesta?.error?.message || 'No existe datos para descargar el documento', true, );

        copiaDeCampos.nombreDelMedio.value= "";
        copiaDeCampos.nombreDeLaEntidad.value= "";
        copiaDeCampos.tipoDeCandidatura.value= "";
        copiaDeCampos.fechaDeGeneracion.value= "";
        copiaDeCampos.comentarioVersion.value= "";
        copiaDeCampos.comentarioInstrucciones.value = "";

        functions.descargarBase64EnPDF(respuesta?.data || "", "ordenDeTransmision.pdf");
        changeDataResponse('success', 'El documento de orden de transmisión de descargo automáticamente', true, );
        setearElementos(copiaDeCampos);
    }

    const buscarFiltro = async (datosDelFormulario) => {
        setListadoDeRegistrosDeMedios( [])
        const {corporacion, tipoDeMedio, nivelDeCobertura, tipoDeCandidatura, fechaDeOrdenes} = datosDelFormulario;

        setcargandoSolicitud(true);
        ServiciosDelAPI[ordenesDeTransmision].setearMetodoPublico(true);
        ServiciosDelAPI[ordenesDeTransmision].metodoDeBusqueda.clear();
        ServiciosDelAPI[ordenesDeTransmision].metodoDeBusqueda.addEquals('habilitado', 1);
        ServiciosDelAPI[ordenesDeTransmision].metodoDeOrden.clear();
        ServiciosDelAPI[ordenesDeTransmision].metodoDeOrden.addAsc("nit_empresa");

        let respuesta = await dispatch(obtenerRegistrosPersonalizadoPublic({
            controller: ordenesDeTransmision,
            saveInStore: false,
            nombreDelMetodo: `listar/registros/${fechaDeOrdenes?.id}/${corporacion?.id}/${tipoDeCandidatura?.id}/${nivelDeCobertura?.id}/${tipoDeMedio?.id || ""}` ,
        }));

        setcargandoSolicitud(false);
        
        if(respuesta?.error) return changeDataResponse('error', respuesta?.error?.message || 'No se pudó obtener los datos', true, );
        
        if(respuesta?.data?.length === 0) return changeDataResponse('error', respuesta?.error?.message || 'No existen datos para este filtro', true, );

        if(!respuesta?.data) return changeDataResponse('error', respuesta?.error?.message || 'No existen datos para este filtro', true, );

        setListadoDeRegistrosDeMedios(respuesta?.data || [])
        datosDelFormularioFiltrado = {...datosDelFormulario};
    }

    const [elementos, setearElementos] = React.useState({
        tituloDatos:{
            idelement: "tituloDatos", title:'Datos de requerimiento de transmisión', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloDatos", value: "", isError:false,
        },
        nombreDelMedio: {
            idelement: "nombreDelMedio",  value: "", label: "Nombre del medio", pattern:"", validators: ['required'], errorMessages:[''], isError:false, elementType:'texto', name:"nombreDelMedio", 'disabled': true, width: '50%'
        },
        nombreDeLaEntidad: {
            idelement: "nombreDeLaEntidad",  value: "", label: "Nombre de la entidad", pattern:"", validators: ['required'], errorMessages:[''], isError:false, elementType:'texto', name:"nombreDeLaEntidad", 'disabled': true, width: '50%'
        },
        tipoDeCandidatura: {
            idelement: "tipoDeCandidatura",  value: "", label: "Tipo de candidatura", pattern:"", validators: ['required'], errorMessages:[''], isError:false, elementType:'texto', name:"tipoDeCandidatura", 'disabled': true, width: '50%'
        },
        fechaDeGeneracion: {
            idelement: "fechaDeGeneracion",  value: "", label: "Período de requerimiento", pattern:"", validators: ['required'], errorMessages:[''], isError:false, elementType:'texto', name:"fechaDeGeneracion", 'disabled': true, width: '50%'
        },
        tituloVersiones:{
          idelement: "tituloVersiones", title:'Versiones registradas para el requerimiento de transmisión', position:"center", elementType:'titulo', showTitleForm: true,  name: "tituloVersiones", value: "", isError:false,
        },
        comentarioVersion:{
            idelement: "comentarioVersion", value: "", label: `Descripción de versiones registradas`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.#_“”]{4,300}$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "comentarioVersion", width: '100%'
        },
        tituloEnlaceMaterial:{
            idelement: "tituloEnlaceMaterial", title:'Enlace de material', position:"center", elementType:'titulo', showTitleForm: true,  name: "tituloEnlaceMaterial", value: "", isError:false,
        },
        enlaceDeMaterial: {
            idelement: "enlaceDeMaterial", value: "", label: "Enlace de material. 'Ejemplo: http(s)://wwww.example.com'", pattern:"", validators: ['required'], errorMessages:['El campo enlace es requerido'], isError:false, elementType:'texto', name:"enlaceDeMaterial", 'disabled': false, keyPress: undefined, width: "100%", autofocus: false
        },
        tituloInstruccionesEspeciales:{
          idelement: "tituloInstruccionesEspeciales", title:'Instrucciones especiales de transmisión', position:"center", elementType:'titulo', showTitleForm: true,  name: "tituloInstruccionesEspeciales", value: "", isError:false,
        },
        comentarioInstrucciones:{
            idelement: "comentarioInstrucciones", value: "", label: `Descripción las instrucciones especiales de transmisión`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.#_“”]{4,300}$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "comentarioInstrucciones", width: '100%'
        },
        acciones:{
            idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
        },
    });

    const cancelAction = () => history.goBack('/')

    const [listadoBotones]= React.useState({
        "saveData":{"label":"Generar", "icon": <Send />, "callback":guardarDatos,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelAction":{"label":"Cancelar", "icon": <Cancel />,"callback":cancelAction,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (errorType, messageType, openResponse = false) => setResponseData({errorType,messageType,openResponse,})

    const cerrarMostrarInformacion= () => setMostrarInformacion(false);

    const { errorType, messageType, openResponse} = responseData;

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose}/>
            <TituloConIcono title={"Requerimiento de Transmisión"} icon={""} mostrarBotones={false} mostrarTiempo={false} />
            <Card>
                <CardContent>
                    <Grid container>
                        <Grid item xs={12} md={6} >
                            <Buscador buscarFiltro={buscarFiltro} salirDelFiltro={cancelAction} />

                            <TablaPersonalizada
                                data={listadoDeRegistrosDeMedios}
                                title={"Listado de requerimientos de transmisión a generar"}
                                header={header}
                                refreshList={undefined}
                                addRegister={undefined}
                                nameToolTipAdd={""}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <Formulario
                                elements={elementos}
                                buttonList={listadoBotones}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            {mostrarInformacion && (
                <MostrarInformacion
                    openFullScreenDialog={mostrarInformacion}
                    handleClose={cerrarMostrarInformacion}
                    informacionObtenida={informacionObtenida}
                    datosDelFormularioFiltrado={datosDelFormularioFiltrado}
                    title={`Listado de Spot a transmitir del ${informacionObtenida?.rangoInicial || ""} AL ${informacionObtenida?.rangoFinal || ""}`}
                />
            )}
        </Fragment>
    );
}

export default GeneracionSolicitudTransmision;